import React, {useEffect} from 'react';
import ReactDOM, {render} from 'react-dom';

import log from '../lib/log.js';
import PropTypes from 'prop-types';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import HashParserHOC from '../lib/hash-parser-hoc.jsx';
import GUI from '../index.js';
import {compose} from 'redux';
//@ts-ignore
import style from '../../styles/Pointing.css';

const onClickLogo = () => {
    window.location = 'https://scratch.mit.edu';
};

const handleTelemetryModalCancel = () => {
    log('User canceled telemetry modal');
};

const handleTelemetryModalOptIn = () => {
    log('User opted into telemetry');
};

const handleTelemetryModalOptOut = () => {
    log('User opted out of telemetry');
};

/*
 * Render the GUI playground. This is a separate function because importing anything
 * that instantiates the VM causes unsupported browsers to crash
 * {object} appTarget - the DOM element to render to
 */
// eslint-disable-next-line react/display-name
const AppTarget = ({
    WrappedGui,
    closeScratch,
    scratchFile,
    once,
    setOnce,
    index,
    isClose,
    baiMau
}) => {
    let Wrapperr = WrappedGui;
    if (!Wrapperr) {
        GUI.setAppElement(document.getElementsByClassName(style.modal)[0]);

        // note that redux's 'compose' function is just being used as a general utility to make
        // the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
        // ability to compose reducers.
        Wrapperr = compose(
            AppStateHOC,
            HashParserHOC
        )(GUI);
    }

    // TODO a hack for testing the backpack, allow backpack host to be set by url param
    const backpackHostMatches = window.location.href.match(
        /[?&]backpack_host=([^&]*)&?/
    );
    const backpackHost = backpackHostMatches ? backpackHostMatches[1] : null;

    const scratchDesktopMatches = window.location.href.match(
        /[?&]isScratchDesktop=([^&]+)/
    );
    let simulateScratchDesktop;
    if (scratchDesktopMatches) {
        try {
            // parse 'true' into `true`, 'false' into `false`, etc.
            simulateScratchDesktop = JSON.parse(scratchDesktopMatches[1]);
        } catch {
            // it's not JSON so just use the string
            // note that a typo like 'falsy' will be treated as true
            simulateScratchDesktop = scratchDesktopMatches[1];
        }
    }

    if (process.env.NODE_ENV === 'production' && typeof window === 'object') {
        // Warn before navigating away
        window.onbeforeunload = () => true;
    }
    return simulateScratchDesktop ? (
        <Wrapperr
            canEditTitle
            isScratchDesktop
            showTelemetryModal
            canSave={false}
            onTelemetryModalCancel={handleTelemetryModalCancel}
            onTelemetryModalOptIn={handleTelemetryModalOptIn}
            onTelemetryModalOptOut={handleTelemetryModalOptOut}
            closeScratch={closeScratch}
            scratchFile={scratchFile}
            once={once}
            setOnce={setOnce}
            index={index}
            // saveTheLastFile={saveTheLastFile}
        />
    ) : (
        <Wrapperr
            canEditTitle
            backpackVisible
            showComingSoon
            backpackHost={backpackHost}
            canSave={false}
            onClickLogo={onClickLogo}
            closeScratch={closeScratch}
            scratchFile={scratchFile}
            once={once}
            setOnce={setOnce}
            index={index}
            isClose={isClose}
            baiMau={baiMau}
        />
    );
};

AppTarget.propTypes = {
    WrappedGui: PropTypes.AppStateWrapper,
    closeScratch: PropTypes.func,
    scratchFile: PropTypes.instanceOf(Blob),
    once: PropTypes.any,
    setOnce: PropTypes.func,
    index: PropTypes.any,
    isClose: PropTypes.bool,
    baiMau: PropTypes.instanceOf(Blob)
};

export default AppTarget;
